var map = {
	"./bookshelves/bookshelf-basic-1.png": 1559,
	"./bookshelves/bookshelf-basic-2.png": 1560,
	"./bookshelves/bookshelf-basic-3.png": 1561,
	"./bookshelves/bookshelf-basic-4.png": 1562,
	"./bookshelves/bookshelf-beach.png": 1563,
	"./bookshelves/bookshelf-chef.png": 1564,
	"./bookshelves/bookshelf-circus.png": 1565,
	"./bookshelves/bookshelf-gamer.png": 1566,
	"./bookshelves/bookshelf-jam.png": 1567,
	"./bookshelves/bookshelf-pirate.png": 1568,
	"./bookshelves/bookshelf-skate.png": 1569,
	"./bookshelves/bookshelf-sports.png": 1570,
	"./bookshelves/bookshelf-winter.png": 1571,
	"./bookshelves/bookshelf-wizard.png": 1572,
	"./floor_items/basketball.png": 1573,
	"./floor_items/chest.png": 1574,
	"./floor_items/coffee-table.png": 1575,
	"./floor_items/electric-guitar.png": 1576,
	"./floor_items/fireplace.png": 1577,
	"./floor_items/football.png": 1578,
	"./floor_items/game-controller.png": 1579,
	"./floor_items/green-skateboard.png": 1580,
	"./floor_items/magic-book.png": 1581,
	"./floor_items/magic-staff.png": 1582,
	"./floor_items/mask.png": 1583,
	"./floor_items/palm-tree.png": 1584,
	"./floor_items/popcorn.png": 1585,
	"./floor_items/red-skateboard.png": 1586,
	"./floor_items/sandcastle.png": 1587,
	"./floor_items/side-table.png": 1588,
	"./floor_items/violin.png": 1589,
	"./floor_items/wand.png": 1590,
	"./sofas/sofa-beach.png": 1591,
	"./sofas/sofa-chef.png": 1592,
	"./sofas/sofa-circus.png": 1593,
	"./sofas/sofa-gamer.png": 1594,
	"./sofas/sofa-jam.png": 1595,
	"./sofas/sofa-pirate.png": 1596,
	"./sofas/sofa-skate.png": 1597,
	"./sofas/sofa-sports.png": 1598,
	"./sofas/sofa-winter.png": 1599,
	"./sofas/sofa-wizard.png": 1600,
	"./wall_items/double-note-poster.png": 1601,
	"./wall_items/dragon-poster.png": 1602,
	"./wall_items/elephant-poster.png": 1603,
	"./wall_items/helm.png": 1604,
	"./wall_items/pirate-flag.png": 1605,
	"./wall_items/rocket-poster.png": 1606,
	"./wall_items/single-note-poster.png": 1607,
	"./wall_items/surfboard.png": 1608,
	"./wall_items/television.png": 1609,
	"./wall_items/window-night-beach.png": 1610,
	"./wall_items/window-night-lake.png": 1611,
	"./wall_items/window-night-mountains.png": 1612,
	"./wall_items/window-snowy-mountains.png": 1613,
	"./wall_items/window-sunny-beach.png": 1614,
	"./wall_items/window-sunny-lake.png": 1615,
	"./wall_items/window-sunny-mountains.png": 1616,
	"./wall_items/window-sunset-beach.png": 1617,
	"./wall_items/window-sunset-lake.png": 1618
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;



//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures .*\.png
// module id = 664
// module chunks = 0